import React, { useState } from 'react'

import {
  Card,
  CircularProgress,
  Grid,
  Typography,
  Collapse,
  Button,
  MenuItem,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  Paper,
  TableBody,
  TextField,
} from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import MuiCurrencyFloatField from 'components/FormField/MuiCurrencyFloatField'
import { selectData } from 'layouts/onboarding'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

import { differenceInYears } from 'date-fns'

function ProductBank({ collapseSections, toggleCollapse, intakeState }) {
  const [quotes, setQuotes] = useState([])
  const [localForm, setLocalForm] = useState({
    typeOfPayment: '',
    amount: 0,
    solveFor: intakeState?.financialFramework?.trackBSolveFor || 'premium',
    income: '',
    premium: '',
    benefitStartAge: 65,
  })
  const [isLoading, setIsLoading] = useState(false)

  const selectStyles = {
    '&>label': {
      fontSize: '14px',
      color: '#75787B',
      top: '-2px',
    },
    '&>label.Mui-focused': {
      fontSize: '1rem',
      color: '#2370ED',
      background: '#fff',
      padding: '0 5px',
      marginLeft: '-5px',
      top: 0,
    },
    '&>label.Mui-focused.Mui-error': {
      color: '#ea0606',
    },
    '&>label.MuiFormLabel-filled, &>label.MuiInputLabel-shrink': {
      fontSize: '1rem',
      background: '#fff',
      padding: '0 5px',
      marginLeft: '-5px',
      top: 0,
    },
    '&>label.MuiFormLabel-filled.Mui-disabled': {
      top: 0,
      background:
        'linear-gradient(to bottom, #fff 0%, #fff 50%, #e9ecef 50%, #e9ecef 100%)',
    },
    '&>div.MuiInputBase-root': {
      padding: '0!important',
      borderRadius: '4px !important',
    },
    '&>div.MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#e9ecef!important',
    },
    '&>div.MuiInputBase-root.Mui-focused': {
      boxShadow: '0 0 0 1.5px #2370ED',
    },
    '&>div>.MuiInputBase-input': {
      width: '100%!important',
      padding: '0.75rem 1.75rem 0.75rem 0.75rem!important',
      display: 'flex',
    },
    '&>div>.MuiInputBase-input>.MuiListItemIcon-root': {
      minWidth: 'unset',
    },
    '&>div>.MuiInputBase-input>.MuiListItemIcon-root>img': {
      height: '20px',
      width: 'auto',
      marginRight: '8px',
    },
    '&>div>.MuiInputBase-input>.MuiListItemText-root>span': {
      fontSize: '14px',
    },
    '&>div.MuiInputBase-root>svg': {
      display: 'block',
      height: '1.5em',
      width: '1.5em',
      top: 'calc(50% - 0.75em)',
    },
  }

  const handleChange = (field) => (value) => {
    if (field === 'solveFor') {
      setQuotes([])
      setLocalForm((prev) => ({
        ...prev,
        income: '',
        premium: '',
      }))
    }
    setLocalForm((prev) => ({ ...prev, [field]: value }))
  }

  const createProductBank = async () => {
    setIsLoading(true)

    // TODO: This login flow should be abstracted away and use the refresh-token api endpoint
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')

    const loginRequestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({
        username: `${process.env.REACT_APP_PRODUCT_BANK_API_USERNAME}`,
        password: `${process.env.REACT_APP_PRODUCT_BANK_API_PASSWORD}`,
      }),
      redirect: 'follow',
    }

    const accessToken = await fetch(
      `${process.env.REACT_APP_PRODUCT_BANK_API_URL}/auth/login`,
      loginRequestOptions
    )
      .then((response) => response.json())
      .then((result) => result.access_token)
      .catch((error) => console.error(error))

    const productBankHeaders = new Headers()

    productBankHeaders.append('Authorization', `Bearer ${accessToken}`)
    productBankHeaders.append('Content-Type', 'application/json')

    const raw = {
      quote: {
        firstName: intakeState.firstName,
        lastName: intakeState.lastName,
        age: differenceInYears(
          new Date(),
          new Date(intakeState?.dateOfBirth || new Date())
        ),
        singlePremium: localForm.income || null,
        payoutAmount: parseInt(localForm.premium, 10) * 12 || null,
        state: selectData.states.find(
          (ac) => ac.value === (intakeState?.state || '')
        ).abbr,
        benefitStartAge: localForm.benefitStartAge,
      },
      limit: 5,
    }

    const requestOptions = {
      method: 'POST',
      headers: productBankHeaders,
      body: JSON.stringify(raw),
      redirect: 'follow',
    }

    fetch(
      `${process.env.REACT_APP_PRODUCT_BANK_API_URL}/quotes`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setQuotes(result.quotes)
        setIsLoading(false)
      })
      .catch((error) => console.error(error))
  }

  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        {/* <Card
            sx={{
              overflow: 'visible',
              textAlign: 'left',
              boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
              backgroundColor: '#f8f9fa',
              borderRadius: 2,
              p: 2,
            }}
          >
            <Grid container columnSpacing={3} rowSpacing={2}>
              <Grid item xs={12}>
                <Typography variant="valueTitle">VALUE POINTS</Typography>
                <Collapse
                  in={collapseSections.annuityapplicationcreator}
                  style={{ width: '100%' }}
                ></Collapse>
              </Grid>
            </Grid>
          </Card> */}
      </Grid>
      <Grid item xs={12} md={8} xl={9} sx={{ pb: 0 }}>
        <Card
          id="productbank"
          sx={{
            overflow: 'auto',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('productbank')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                Product Bank
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.productbank
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse in={collapseSections.productbank} style={{ width: '100%' }}>
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              <Grid item xs={6} md={4}>
                <TextField
                  id="trackB-solve-for"
                  label="Solve For"
                  value={localForm.solveFor}
                  onChange={(e) => handleChange('solveFor')(e.target.value)}
                  fullWidth
                  select
                  sx={selectStyles}
                >
                  <MenuItem value={'income'}>Income</MenuItem>
                  <MenuItem value={'premium'}>Premium</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={6} md={4}>
                {renderMuiFormField({
                  label:
                    localForm.solveFor === 'income'
                      ? 'Annuity Premium Amount'
                      : 'Desired Monthly Income Amount',
                  shrink: true,
                  placeholder:
                    localForm.solveFor === 'income'
                      ? '$100,000.00'
                      : '$2,000.00',
                  inputType: 'currencyFloat',
                  value:
                    localForm.solveFor === 'income'
                      ? localForm.income
                      : localForm.premium,
                  onChange: (e) => {
                    if (localForm.solveFor === 'income') {
                      handleChange('income')(e)
                    } else {
                      handleChange('premium')(e)
                    }
                  },
                  // onBlur: onBlur,
                })}
                {/* <MuiCurrencyFloatField
                  shrink
                  label={
                    localForm.solveFor === 'income'
                      ? 'Annuity Premium Amount'
                      : 'Desired Monthly Income Amount'
                  }
                  placeholder={
                    localForm.solveFor === 'income'
                      ? '$100,000.00'
                      : '$2,000.00'
                  }
                  value={
                    localForm.solveFor === 'income'
                      ? localForm.income
                      : localForm.premium
                  }
                  onChange={(e) => {
                    if (localForm.solveFor === 'income') {
                      handleChange('income')(e)
                    } else {
                      handleChange('premium')(e)
                    }
                  }}
                /> */}
              </Grid>
              <Grid item xs={6} md={4}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'benefitStartAge',
                  label: 'Benefit Start Age',
                  placeholder: 'Benefit Start Age',
                  inputType: 'select',
                  value: localForm.benefitStartAge,
                  onChange: (e) => handleChange('benefitStartAge')(e),
                  options: selectData.retirementSSYear,
                })}
              </Grid>
              {quotes && quotes.length > 0 && (
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="product bank table">
                    <TableHead sx={{ display: 'contents' }}>
                      <TableRow>
                        <TableCell>Carrier</TableCell>
                        <TableCell>Annuity</TableCell>
                        <TableCell>Rating</TableCell>
                        <TableCell>
                          {localForm.solveFor === 'premium'
                            ? 'Premium'
                            : 'Income'}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {quotes.slice(0, 5).map((quote, index) => (
                        <TableRow
                          key={`${quote.companyName}-${index}`}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 },
                          }}
                        >
                          <TableCell align="left">
                            {quote.companyName}
                          </TableCell>
                          <TableCell align="left">
                            {quote.annuityName}
                          </TableCell>
                          <TableCell align="left">{quote.bestRating}</TableCell>
                          <TableCell align="left">
                            $
                            {localForm.solveFor === 'premium'
                              ? quote.incomeStart.quotePremium
                              : quote.incomeStart.incomeAmount / 12}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  onClick={createProductBank}
                  disabled={false}
                  sx={{
                    padding: '8px 24px',
                    backgroundColor: '#2370ED',
                    border: '2px solid #2370ED',
                    color: '#fff',
                    boxShadow: 'none',
                    borderRadius: '100px',
                    textTransform: 'capitalize',
                    fontWeight: 600,
                    fontSize: '18px',
                    lineHeight: 1.5,
                    marginTop: '8px',
                    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                      transform: 'none',
                      backgroundColor: '#1c59bd',
                      borderColor: '#1c59bd',
                      boxShadow: 'none',
                    },
                    '&:disabled': {
                      borderColor: 'rgba(0,0,0,0)',
                    },
                  }}
                >
                  {!isLoading && 'Create Product Bank'}
                  {isLoading && (
                    <CircularProgress size="30px" color="inherit" />
                  )}
                </Button>
              </Grid>
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default ProductBank
